import { useState, type FC } from "react";
import Nav from "../Nav";
import Header from "../Header";
import { Outlet } from "react-router";
import LayoutLoading from "../LayoutLoading.tsx";
import { userState } from "@/store/userState.ts";
import { SidebarProvider } from "../ui/sidebar.tsx";
import AppSidebar from "../SideBar/index.tsx";

const Layout: FC = () => {
  const { isLoading } = userState();
  const [open, setOpen] = useState(true);

  if (isLoading) return <LayoutLoading />;

  return (
    <SidebarProvider open={open} onOpenChange={setOpen}>
      <Nav />
      <AppSidebar setOpen={setOpen} open={open} />
      <main className="h-screen w-[100%] overflow-hidden">
        <Header />
        <Outlet />
      </main>
    </SidebarProvider>
  );
};

export default Layout;
